import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-30 flex min-h-[76px] items-center justify-between border-b border-slate-200 bg-white/95 px-4 backdrop-blur sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex min-w-0 items-center gap-3" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "min-w-0 text-right" }
const _hoisted_5 = { class: "truncate text-base font-bold text-slate-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-slate-600 transition hover:bg-slate-100 hover:text-cyan-800 focus:outline-none focus:ring-2 focus:ring-cyan-700 lg:hidden",
        "aria-label": "باز کردن منوی مدیریت",
        "aria-expanded": _ctx.sidebarOpen,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [
        _createVNode(_component_v_icon, { size: "23" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.sidebarOpen ? 'mdi-close' : 'mdi-menu'), 1)
          ]),
          _: 1
        })
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.pageTitle), 1),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "hidden text-xs text-slate-500 sm:block" }, "مدیریت امن و یکپارچهٔ SayyarPay", -1))
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "inline-flex shrink-0 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-600 transition hover:border-rose-200 hover:bg-rose-50 hover:text-rose-700 focus:outline-none focus:ring-2 focus:ring-rose-500 sm:px-4",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
    }, [
      _createVNode(_component_v_icon, { size: "19" }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("mdi-logout", -1)
        ]))]),
        _: 1
      }),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "hidden sm:inline" }, "خروج امن", -1))
    ])
  ]))
}